export default __webpack_public_path__ + "static/media/task_active_appointment_icon.94bf09f0.svg";